jQuery(window).on('load', function () {
    var stripe;
    var card;

    function initStripe(){
        if ((location.pathname.indexOf('/updatePayment') !== -1) ||
                // (location.pathname.indexOf('/makePayment') !== -1) ||
                (location.pathname.indexOf('/payment-method') !== -1)||
                // (location.pathname.indexOf('/users/edit') !== -1)||
                // (location.pathname.indexOf('/accounts/edit') !== -1)||
                (location.pathname.indexOf('/billing') !== -1)) {

            $.get($('body').data('base-url') + "payment-method/creds", function( data ) {
                var res = JSON.parse(data);
                if(res.key){
                    stripe = Stripe(res.key);
                    var elements = stripe.elements();
    
                    card = elements.create('card');
                    if($('#card-element').length)
                        card.mount('#card-element');
                }else{
                    $('#card-element').html('<p style="color:red">Card details field is not appearing, please refresh the page.</p>');
                }
                if($('.change_subscription').length && $('.change_subscription:checked').val() == "account-level")
                    change_subscription(1);

                initEvents();
            }).fail(function(jqXHR, textStatus, error){
                $('#card-element').html('<p style="color:red">Card details field is not appearing, please refresh the page.</p>');
            });

        }
    }

    function getStripe(){
        return stripe;
    }

    function getCard(){
        return card;
    }

    function stripeTokenHandler(token) {
        // Insert the token ID into the form so it gets submitted to the server
        var form = $("#payment-form");

        var hiddenInput = document.createElement('input');

        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', 'stripeToken');
        hiddenInput.setAttribute('value', token.id);

        form.append(hiddenInput);
        $("#subscription_plan").modal('close');

        // Submit the form

        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            dataType: 'json',
            headers: {
                stripeToken: token.id
            },
            data: form.serialize(),
            success: function (result) {
                $(".overlay").hide();

                var button = $('[type=submit]');
                // Check if the message was rejected

                var message = null;

                if (typeof result.message !== null) {
                    message = result.message;
                }

                if (result.status === 'failed') {
                    Materialize.toast('Sorry! ' + message, 2000);

                    button
                        .attr("disabled", false)
                        .removeClass('submitting');

                    return;
                }
                if(message) {
                    Materialize.toast(message, 2000);
                }

                // Notify of successful payment
                //Materialize.toast('Payment successful!  Thank you!', 10000, 'success');

                // Add the success class and change the inner text
                button
                    .attr("disabled", false)
                    .removeClass('submitting');

                getCard().clear();

                setTimeout(function () {
                    button
                        .removeClass('success')
                        .attr("disabled", false);

                    var entity = $('input[name="entity"]').val();

                    if(entity === 'account' || entity === 'user') {
                    //     var account_id = $('input[name="account_id"]').val();

                    //     if(!isNaN(account_id) && account_id !== undefined ) {
                    //         window.location.href = $("body").data("base-url") + "billing/listing/" + account_id;
                    //     }
                    // } else if(entity === 'user') {
                        var user_id = $('input[name="user_id"]').val();

                        if(!isNaN(user_id) && user_id !== undefined ) {
                            window.location.href = $("body").data("base-url") + "billing/listing/" + user_id;
                        }
                    } else {
                        window.location.href = $("body").data("base-url").toString();
                    }


                }, 2000);

            },
            error: function (xhr, ajaxOptions, thrownError) {
                $(".overlay").hide();
                stopoading('body');

                Materialize.toast(thrownError, 5000, 'error');

                $('[type=submit]')
                    .attr("disabled", false)
                    .removeClass('submitting');
            }
        });
    }

    function createToken(form) {
        getStripe().createToken(getCard()).then(function (result) {
            if (result.error) {
                // Inform the user if there was an error
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
            } else {
                $(".overlay").show();
                startLoading('body');

                // No pressing the buy now button more than once
                form.find('[type=submit]').prop('disabled', true).addClass('submitting');

                // Send the token to your server
                stripeTokenHandler(result.token);
            }
        });
    }

    function initEvents() {
        // Create a token when the form is submitted.

        var form = $("#payment-form");

        form.on('submit', function (e) {
            var form = $(this);

            e.preventDefault();

            createToken(form);
        });

        getCard().addEventListener('change', function(event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });
    }

    initStripe();
});